import React from "react";
import { css } from "@emotion/css";
import { Theme } from 'evcharging/app/themes';
import useTheme from "evcharging/hooks/useTheme";

export const ServiceUtilitiesList = ({ utilities }) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <div className={styles.wrapper}>
      <div className={styles.root}>
        {utilities.map(el => (
          <div key={el.id}>
            <div className={styles.title}>
              {el.title}
            </div>

            <div className={styles.description} dangerouslySetInnerHTML={{ __html: el.description }} />
          </div>
        ))}
      </div>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  wrapper: css`
    max-width: 1280px;
    margin: auto;
    padding: 100px 15px;
  `,
  root: css`
    display: grid;
    grid-column-gap: 30px;
    grid-row-gap: 46px;
    ${theme.breakpoints.mobile.up} {
      grid-template-columns: 1fr 1fr 1fr;
    };
    ${theme.breakpoints.mobile.down} {
      grid-template-columns: 1fr;
    }
  `,
  title: css`
    color: #252C32;
    font-size: 32px;
    font-weight: 700;
    line-height: 130%;
  `,
  description: css`
    color: #6E7C87;
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
  `
});

export default ServiceUtilitiesList
